<template>
  <div
    class="c-app-bare"
    :class="{
      [`c-app-bare__${route.name}`]: true,
      [`c-app-bare__${route.name}__background`]: withBackground,
    }"
  >
    <BittsBanner
      v-if="showBanner"
      message="Reveal merged with Crossbeam to create the world's #1 platform for Ecosystem-Led Growth, and you’re a few steps away from unlocking all its benefits!"
      variant="primary"
    />
    <nav class="c-app-bare__nav">
      <router-link :to="{ name: 'main' }" class="c-app-bare__logo">
        <template v-if="isXSmall">
          <BittsSvg
            v-if="!showBanner"
            svg="logoNoText"
            class="h-32 w-32"
            alt="Crossbeam"
          />
          <div v-else class="c-app-bare__logo__inner">
            <BittsSvg svg="logoNoText" class="h-32 w-32" alt="Crossbeam" />
            <BittsSvg :svg="'x'" class="h-10 mt-8 pl-2" alt="x" />
            <BittsSvg
              :svg="'revealLogoPurple'"
              class="h-32 w-32"
              alt="Reveal"
            />
          </div>
        </template>
        <template v-else>
          <BittsSvg
            v-if="!showBanner"
            :svg="withBackground ? 'logoWhite' : 'logo'"
            class="h-24"
            alt="Crossbeam"
          />
          <div v-else class="c-app-bare__logo__inner">
            <BittsSvg
              :svg="withBackground ? 'logoWhite' : 'logo'"
              class="h-24"
              alt="Crossbeam"
            />
            <BittsSvg :svg="'x'" class="h-10 mt-8" alt="x" />
            <BittsSvg :svg="'revealLogoNamePurple'" class="h-30" alt="Reveal" />
          </div>
        </template>
      </router-link>
      <BittsButton
        v-if="isLoggedIn && !isMinimalView"
        class="logout-button"
        :variant="withBackground ? 'fill' : 'outline'"
        :type="withBackground ? 'white' : 'neutral'"
        text="Log out"
        :right-icon="['fak', 'logout']"
        @click="handleLogout"
      />
    </nav>
    <section class="c-app-bare__content">
      <router-view-wrapper @with-background="withBackground = true" />
    </section>
    <toasts />
  </div>
</template>

<script setup>
import { BittsBanner, BittsButton, BittsSvg } from '@crossbeam/bitts';
import { useScreenSize } from '@crossbeam/pointbreak';

import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import Toasts from '@/components/layout/Toasts.vue';

import useAuth from '@/composables/useAuth';
import useMinimalApp from '@/composables/useMinimalApp';
import useReferrer from '@/composables/useReferrer';

const { isMinimalView } = useMinimalApp();

const route = useRoute();
const router = useRouter();

const { isXSmall } = useScreenSize();
const { isLoggedIn } = useAuth();
const { isFromReveal } = useReferrer();

const showBanner = computed(
  () =>
    isFromReveal.value &&
    (route.name == 'register-public' ||
      route.name === 'register-public-params'),
);

async function handleLogout() {
  await router.push({ name: 'logout', query: { next: 'register' } });
}

/* If the child notifies us that it's using a background we want to use light variants
of our buttons and logos. */
const withBackground = ref(false);
</script>
<style lang="pcss" scoped>
.c-app-bare {
  @apply flex flex-col grow min-h-screen;
}

.c-app-bare__logo__inner {
  @apply flex items-center gap-16;
}

.c-app-bare__content {
  @apply flex flex-col flex-1 justify-center;
}

.c-app-bare__nav {
  @apply pb-0 px-40 pt-16 w-full justify-center sm:justify-between flex mb-40 md:mb-0;
}

.c-app-bare .c-toasts {
  @apply top-[56px] md:top-[86px];
}

.logout-button {
  @apply hidden sm:flex;
}
</style>
